import { Types } from 'cafe-utility';
import { Reference } from "./typed-bytes.js";
export class ResourceLocator {
  constructor(raw) {
    this.raw = raw;
  }
  toString() {
    if (Types.isString(this.raw) && this.raw.includes('.eth')) {
      return this.raw;
    }
    return new Reference(this.raw).toHex();
  }
}